// extracted by mini-css-extract-plugin
export default {"types":"TypeAsset_types__8TaUD","contents":"TypeAsset_contents__62s2y"};